import { defineComponent as _defineComponent } from 'vue'
import { convertCharAndConvertToHtml } from '@/heplers';
import type { translation } from '@/templates/References';


export default /*#__PURE__*/_defineComponent({
  __name: 'Returns',
  props: {
    returns: null
  },
  setup(__props: any) {



const convertToHtml = (mdString: string | object) => {
  if (typeof mdString === 'object') return mdString;
  return convertCharAndConvertToHtml(mdString as string);
};

return { __sfc: true,convertToHtml }
}

})